import Compressor from "compressorjs";

export default class ImageCompressor {

    // check if browser support export canvas to compressed image.
    // for example, safari doesn't support export to webp
    static isBlobToTypeSupported(mimeType) {
        try {
            // create small canvas image and try to save it
            const canvas = document.createElement('canvas');
            canvas.width = canvas.height = 32;

            return canvas.toDataURL(mimeType).indexOf('data:' + mimeType) == 0;
        } catch (error) {
            return false;
        }
    }

    static selectFormat() {
        // some browsers may not support webp or jpeg
        if (this.isBlobToTypeSupported('image/webp')) return 'image/webp';
        if (this.isBlobToTypeSupported('image/jpeg')) return 'image/jpeg';

        // all browsers support png
        return 'image/png';
    }

    static compress(blob, MaxWidth, MaxHeight, onLoaded, onError) {
        new Compressor(blob, {
            mimeType: this.selectFormat(),
            maxHeight: MaxHeight,
            maxWidth: MaxWidth,
            success: (result) => {
                onLoaded(result);
            },
            error(err) {
                onError(err.message);
            },
        });
    }
}